<template>
  <div>
    <div class="form-all">
      <div class="win">
        <slot name="title"></slot>
        <div class="form">
          <section class="form-main" ref="form">
            <!-- 姓名 -->
            <div v-for="(item, index) in [infoConfig['name']]" :key="`name-${index}`">
              <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                <input
                slot="input"
                class="text-input"
                type="text"
                placeholder="请输入姓名"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
              </form-item>
            </div>
            <!-- 性别&生日 -->
            <div class="field-gender">
              <div v-for="(item, index) in [infoConfig['gender']]" class="tgo-gender" :key="`gender-${index}`">
                <form-item :item="item" :haveBorder="false" :ref="item.key" @setOKList="setOKList">
                  <tgo-radio
                  slot="input"
                  :labels="item.labels"
                  :tkey="item.key"
                  :value="info[item.key]"
                  @input="getValue"
                  @focus="focusInput(item)"
                  @blur="blurItem(item)">
                  </tgo-radio>
                </form-item>
              </div>
              <div v-for="(item, index) in [infoConfig['birthday']]" class="tgo-birthday" :key="`birthday-${index}`">
                <form-item :item="item" :ref="item.key" :iview="true" :modify="false" :haveBorder="false" @setOKList="setOKList">
                  <DatePicker
                  slot="input"
                  type="date"
                  :tKey="item.key"
                  :value="info[item.key]"
                  placeholder="请选择生日日期"
                  @input="getValue"
                  @focus="focusItem(item)"
                  @blur="blurItem(item)"
                  ></DatePicker>
                </form-item>
              </div>
            </div>
            <!-- 手机号 -->
            <!-- <form-item :item="{name: '手机号', required: true}" :haveBorder="false" :modify="false">
              <div slot="input">
                {{info['area_code']+info['phone']}}
                <span style="margin-left:15px;font-size:12px;color:#868686">备注：如需修改手机号，请联系客服。</span>
              </div>
            </form-item> -->
            <form-item :item="formPhone" :haveBorder="false" :iview="true">
              <account-phone slot="input" ref="account" :phone="tgoUserInfo['phone']" :areaCode="parseInt(tgoUserInfo['area_code'].substr(1))"></account-phone>
            </form-item>
            <!-- e-mail -->
            <div v-for="(item, index) in [infoConfig['email']]" :key="`email-${index}`">
              <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                <input
                slot="input"
                class="text-input"
                placeholder="请输入邮箱"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
              </form-item>
            </div>
            <!-- 微信号 -->
            <div v-for="(item, index) in [infoConfig['wechat']]" :key="`wechat-${index}`">
              <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                <!-- TODO: 同手机号 -->
                <!-- <span slot="extra" class="wechat-extra">
                  <label for="wechat">
                    <input type="checkbox" id="wechat" v-model="sameWithPhone"/><span>同手机号</span>
                  </label>
                </span> -->
                <!-- <tgo-phone
                slot="input"
                :tkey="item.key"
                :value="info[item.key]"
                placeholder="请输入微信号"
                @input="getValue"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
                </tgo-phone> -->
                <input
                class="text-input"
                slot="input"
                :tkey="item.key"
                v-model="info[item.key]"
                placeholder="请输入微信号"
                @focus="focusItem(item)"
                @blur="blurItem(item)" />
              </form-item>
            </div>
            <!-- 所在城市 -->
            <!-- <tgo-city @exportValue="getValue" :regCity="regCity" :info="info" ref="tgoCity"></tgo-city> -->
            <!-- 个人专注领域 -->
            <div v-for="(item, index) in [infoConfig['focus_areas_tags']]" :key="`fat-${index}`">
              <form-item :item="item" :ref="item.key" @setOKList="setOKList" :iview="true">
               <auto-match-input
                slot="input"
                dataSource="ajax"
                :types="tagTypes"
                :tkey="item.key"
                :value="(info[item.key] && info[item.key]['1']) || []"
                placeholder="请输入关键词，如无匹配领域，请选择其他。"
                @setSelectedTypes="getValue"
                @searchKey="debounceSearchTags"
                @focus="focusItem(item)"
                @blur="blurItem(item)"
                ></auto-match-input>
              </form-item>
            </div>
            <!-- 期望加入的分会 -->
            <div v-for="(item, index) in [infoConfig['expect_to_join']]" :key="`etj-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false">
                <!-- <auto-match-input
                slot="input"
                :types="branchAll"
                :tkey="item.key"
                @setSelectedTypes="getValue"
                @focus="focusItem(item)"
                @blur="blurItem(item)"
                ></auto-match-input> -->
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="branchAll"
                :value="info[item.key]"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 是否愿意参与、组织学员交流活动 -->
            <!-- <div v-for="item in [infoConfig['willingness_to_participate']]">
              <form-item :item="item" :ref="item.key" :haveBorder="false" @setOKList="setOKList">
                <div slot="extra2" class="subTitle">{{item.subTitle}}</div>
                <tgo-checkbox
                  slot="input"
                  :labels="item.labels"
                  :tkey="item.key"
                  :value="info[item.key]"
                  @input="getValue"
                  @focus="focusInput(item)"
                  @blur="blurItem(item)">
                </tgo-checkbox>
              </form-item>
            </div> -->
            <!-- 穿衣尺码 -->
            <div v-for="(item, index) in [infoConfig['size']]"
            :key="`size-${index}`">
              <form-item :item="item" :ref="item.key" :haveBorder="false" layout="apply" @setOKList="setOKList">
                <tgo-radio
                  slot="input"
                  inputStyle="radio"
                  layout="column-2"
                  :labels="item.labels"
                  :tkey="item.key"
                  :value="info[item.key]"
                  @input="getValue"
                  @focus="focusInput(item)"
                  @blur="blurItem(item)">
                </tgo-radio>
              </form-item>
            </div>
            <div class="save-cancel-btns">
              <div class="cancel-btn" @click="cancelHandler">取消</div>
              <div class="save-btn" @click="submit">保存</div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import infoConfig from './info-config'
import service from '@/service'
import formItem from '@/components/form/form.item.com'
// import { AutoComplete } from 'iview'
import { autoMatchInput } from '@/components/auto-match'
import tgoRadio from '@/components/form/radio'
// import tgoPhone from '@/components/form/phone'
// import tgoPhone from './phone'
import AccountPhone from '@/views/apply-form/form-info/AccountPhone'
// import tgoCheckbox from '@/components/form/checkbox'
import tgoSelect from '@/components/form/select'
// import tgoCity from './linkSelect'
import DatePicker from '@/components/form/date-picker'
// import saveCancel from '@/components/account/save.cancel.vue'
import lodash from 'lodash'

import * as GlobalLayer from '@/util/globalLayer'

// static 数据
import { getBranchAll } from '@/util/methods.js'

export default {
  data () {
    return {
      infoConfig,
      warn: {},
      tagTypes: [],
      tagsMapId: {},
      sameWithPhone: false,
      branchAll: [],
      // regCity: true,
      // phone
      formPhone: {
        key: 'phone',
        name: '手机号',
        required: true
      },
      showTip: false
    }
  },
  components: {
    formItem,
    autoMatchInput,
    // AutoComplete,
    DatePicker,
    tgoRadio,
    // tgoPhone,
    AccountPhone,
    // tgoCheckbox,
    tgoSelect
    // tgoCity,
    // saveCancel
  },
  created () {
    this.debounceSearchTags = lodash.debounce(this.SearchTags, 500)
    // get 分会数据
    getBranchAll().then(data => { this.branchAll = data })
      .catch(err => { console.log(err) })
  },
  props: ['info', 'tgoUserInfo'],
  methods: {
    submit () {
      // 深比较
      if (!lodash.isEqual(this.info, this.tgoUserInfo)) {
        for (let key in this.infoConfig) {
          if (this.infoConfig[key].required) {
            this.blurItem(this.infoConfig[key])
          }
        }
        // if (String(this.info['country']) && String(this.info['province']) && String(this.info['city'])) {
        //   this.regCity = true
        // } else {
        //   this.regCity = false
        // }
        for (let key in this.warn) {
          if (this.warn[key] === false) {
            return
          }
        }
        // 验证手机号组件
        if (!this.$refs['account'].check()) {
          return
        }
        this.$emit('submit', {
          ...this.info,
          ...this.$refs['account'].data()
        })
      } else {
        this.$emit('submit', {
          ...this.info,
          ...this.$refs['account'].data()
        })
      }
    },
    blurItem (item) {
      this.$refs[item.key][0].blurFn(item, this.info)
    },
    focusItem (item) {
      this.$refs[item.key][0].focused = true
    },
    getValue (data) {
      if (data.key === 'focus_areas_tags') {
        this.info[data.key] = { '1': data.value }
      } else {
        this.info[data.key] = data.value
      }
    },
    /**
     * 存储已经符合规格的input的键值集合
     */
    setOKList (item) {
      if (item.warning.valid) {
        this.warn[item.key] = true
      } else {
        this.warn[item.key] = false
      }
    },
    SearchTags (value) {
      if (!value.trim()) return
      service.getTags({ 'name': value.trim() })
        .then(data => {
          this.tagTypes = []
          if (data.length) {
            data.forEach(item => {
              item.name = item.tag_name
            })
            this.tagTypes = data
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    // cancelConfirm () {
    //   this.showTip = false
    //   this.$emit('setState')
    // },
    cancelHandler () {
      GlobalLayer.createModal(this.$store, {
        title: '温馨提示',
        content: '<h2>取消后您的修改将会丢失</h2><h3>确认取消？</h3>',
        on: {
          confirm: (layer) => {
            this.$emit('setState')
            layer.close()
          }
        }
      })
    }
  },
  computed: {
  },
  mounted () {
  },
  watch: {
    // 裁剪字数
    'info.name': {
      handler: function (n) {
        if (n.length > 20) {
          this.info['name'] = this.info['name'].slice(0, 20)
        }
      }
    },
    'info.email': {
      handler: function (n) {
        if (n.length > 50) {
          this.info['email'] = this.info['email'].slice(0, 50)
        }
      }
    },
    'info.wechat': {
      handler: function (n) {
        if (n.length > 50) {
          this.info['wechat'] = this.info['wechat'].slice(0, 50)
        }
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import '../../../../../style/bulma/app.sass'

.fade-enter-active, .fade-leave-active
  transition: opacity .3s
.fade-enter, .fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */
  opacity: 0

input
  width: 100%
  &::-webkit-input-placeholder  /* WebKit, Blink, Edge */
    color: #bbbec4
    font-size: 12px
  &:-moz-placeholder  /* Mozilla Firefox 4 to 18 */
    color: #bbbec4
    font-size: 12px
  &::-moz-placeholder  /* Mozilla Firefox 19+ */
    color: #bbbec4
    font-size: 12px
  &:-ms-input-placeholder /* Internet Explorer 10-11 */
    color: #bbbec4
    font-size: 12px

.wechat-extra
  margin-right: 15px
  label
    width: 200px
    cursor: pointer
    input
      width: auto
      margin-right: 10px

.form-all
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  +mobile
    margin: 0
  .win
    width: 100%
    position: relative
    .form
      background-color: #fff
      .form-main
        width: 80%
        .field-gender
          display: flex
          justify-content: space-between
          .tgo-birthday
        .submit
          display: flex
          justify-content: center
          margin-top: 40px
          .input
            display: flex
            justify-content: center
            width: 250px
            height: 50px
            border: 2px solid #D7B375
            color: $primary3
            font-size: 16px
            text-align: center
            outline: none
            margin: 0 auto
            cursor: pointer

// slot 相关
.subTitle
  margin: -15px 0 12px 14px
  font-size: 14px
  color: #888

// btn 相关
.save-cancel-btns
  display: flex
  justify-content: flex-end
  align-items: baseline
  .cancel-btn
    padding: 6px 76px
    border: 1px solid $primary3
    border-radius: 5px
    color: $primary3
    margin-right: 20px
    cursor: pointer
  .save-btn
    padding: 6px 76px
    border: 1px solid $primary3
    border-radius: 5px
    background-color: $primary3
    color: #fff
    cursor: pointer

</style>
